import styled from 'styled-components';
import { Sidebar, Image, Responsive } from 'semantic-ui-react';

export const WelcomeText = styled.p`
  font-size: 1.8em;
`;

export const InfoText = styled.p`
  font-size: 1em;
  margin-bottom: 1em;
`;

export const Logo = styled(Image)`
  width: 12em;
`;

export const Imag = styled(Image)`
  width: 8em;
`;

export const Confiax = styled.div`
  margin-top: 2em;
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const Pushable = styled(Sidebar.Pushable)`
  height: 100vh !important;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-y: hidden !important;
  position: relative;
`;

export const FormContainer = styled.div`
  margin-top: 4em;
`;

export const SideBarGrid = styled(Responsive)`
  height: 100%;
  width: 30vw; /* Ocupa 30% da largura */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em 4em;

  @media (max-width: 768px) {
    flex: 1;
    padding: 1em;
  }
`;

export const Pusher = styled(Sidebar.Pusher)`
  flex: none; /* Remove o flex para que a imagem não mude de lugar */
  width: 70vw; /* Ocupa 70% da largura da tela */
  position: absolute; /* Faz a imagem ficar fixa à direita */
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    display: none; /* Esconde a imagem no mobile */
  }
`;

export const ImageBackgroundCover = styled.div`
  position: absolute;
  height: 100vh;
  width: 100%;
  background-color: #0061ff;
  z-index: -1;
  opacity: 0.6;
`;

export const ImageBackground = styled(Image)`
  height: 100vh; /* Ocupa toda a altura da tela */
  width: 100%; /* Faz a imagem ocupar 100% do container */
  object-fit: cover; /* Ajusta a imagem para cobrir o container */
  position: relative;
`;

export const ImageBackgroundText = styled.div`
  font-size: 2em;
  line-height: 1.5em;
  color: white;
  width: 100%;
  text-align: center;
  margin-top: 1em;
`;
